/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Search_Modal_OpeningInputs */

const en_domain_search_modal_opening = /** @type {(inputs: Domain_Search_Modal_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening...`)
};

const es_domain_search_modal_opening = /** @type {(inputs: Domain_Search_Modal_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abriendo...`)
};

const fr_domain_search_modal_opening = /** @type {(inputs: Domain_Search_Modal_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouverture...`)
};

const de_domain_search_modal_opening = /** @type {(inputs: Domain_Search_Modal_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird geöffnet...`)
};

/** @type {(inputs: Domain_Search_Modal_OpeningInputs) => LocalizedString} */
const ja_domain_search_modal_opening = en_domain_search_modal_opening;

/** @type {(inputs: Domain_Search_Modal_OpeningInputs) => LocalizedString} */
const zh_domain_search_modal_opening = en_domain_search_modal_opening;

/** @type {(inputs: Domain_Search_Modal_OpeningInputs) => LocalizedString} */
const ar_domain_search_modal_opening = en_domain_search_modal_opening;

/** @type {(inputs: Domain_Search_Modal_OpeningInputs) => LocalizedString} */
const id_domain_search_modal_opening = en_domain_search_modal_opening;

/** @type {(inputs: Domain_Search_Modal_OpeningInputs) => LocalizedString} */
const it_domain_search_modal_opening = en_domain_search_modal_opening;

/** @type {(inputs: Domain_Search_Modal_OpeningInputs) => LocalizedString} */
const ru_domain_search_modal_opening = en_domain_search_modal_opening;

/** @type {(inputs: Domain_Search_Modal_OpeningInputs) => LocalizedString} */
const pt_domain_search_modal_opening = en_domain_search_modal_opening;

/** @type {(inputs: Domain_Search_Modal_OpeningInputs) => LocalizedString} */
const ko_domain_search_modal_opening = en_domain_search_modal_opening;

/**
* | output |
* | --- |
* | "Opening..." |
*
* @param {Domain_Search_Modal_OpeningInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_opening = /** @type {((inputs?: Domain_Search_Modal_OpeningInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_OpeningInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_opening(inputs)
	if (locale === "es") return es_domain_search_modal_opening(inputs)
	if (locale === "fr") return fr_domain_search_modal_opening(inputs)
	if (locale === "de") return de_domain_search_modal_opening(inputs)
	if (locale === "ja") return ja_domain_search_modal_opening(inputs)
	if (locale === "zh") return zh_domain_search_modal_opening(inputs)
	if (locale === "ar") return ar_domain_search_modal_opening(inputs)
	if (locale === "id") return id_domain_search_modal_opening(inputs)
	if (locale === "it") return it_domain_search_modal_opening(inputs)
	if (locale === "ru") return ru_domain_search_modal_opening(inputs)
	if (locale === "pt") return pt_domain_search_modal_opening(inputs)
	return ko_domain_search_modal_opening(inputs)
});